export default __webpack_public_path__ + "static/media/boar_grayscale.7141e0dd.svg";